import React from 'react';
import { Badge } from 'reactstrap';

function QueueJobRequestStatusField({ value, maxLength }) {
  if (!value) return <>-</>;

  if (value === 'NOT_INITIALIZED') {
    return (
      <div className="master-special">
        <Badge>Non in gestione</Badge>
      </div>
    );
  } else if (value === 'PENDING') {
    return (
      <div className="master-paid">
        <Badge>In gestione</Badge>
      </div>
    );
  } else if (value === 'COMPLETED') {
    return (
      <div className="master-yes">
        <Badge>Completata</Badge>
      </div>
    );
  } else {
    return <>-</>;
  }
}

export default QueueJobRequestStatusField;
